import {Injectable} from '@angular/core';
import 'rxjs/add/operator/toPromise';

import {AppService} from "../app.service";
import {HEADERS, URL_API} from "../constante";

@Injectable()
export class UsuarioService extends AppService {

     documentoUrl = URL_API + '/usuario';

    setPerfil(dados){
        let url= this.documentoUrl+"/perfilsys";
        return this.http
            .post(url, JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

    setDesativado(dados){
        let url= this.documentoUrl+"/desativado";
        return this.http
            .post(url, JSON.stringify(dados), {headers: HEADERS})
            .toPromise()
            .then(response => this.utils.handle(response))
            .catch((error) => this.utils.handleError(error));
    }

}



// WEBPACK FOOTER //
// ./src/app/usuario/usuario.service.ts